/* -------------------------------------------------------------------------- */
/*                                Toast styles                                */
/* -------------------------------------------------------------------------- */

@import './bq-toast.variables';

:host {
  @apply inline-block;
}

:host(.is-hidden) {
  @apply hidden;
}

.bq-toast {
  @include animation-slide-in;
  @apply flex items-center gap-[--bq-toast--gap] p-b-[--bq-toast--padding-y] p-i-[--bq-toast--padding-x];
  @apply rounded-[--bq-toast--border-radius] bg-[--bq-toast--background] shadow-[shadow:--bq-toast--box-shadow];
  @apply border-[length:--bq-toast--border-width] border-[color:--bq-toast--border-color];

  border-style: var(--bq-toast--border-style);
}

.bq-toast--icon {
  @apply flex;

  &.info {
    @apply text-[--bq-toast--icon-color-info];
  }

  &.success {
    @apply text-[--bq-toast--icon-color-success];
  }

  &.alert {
    @apply text-[--bq-toast--icon-color-alert];
  }

  &.error {
    @apply text-[--bq-toast--icon-color-error];
  }

  &.loading {
    @include animation-spin;
    @apply text-[--bq-toast--icon-color-loading];
  }

  &.custom {
    @apply text-[--bq-toast--icon-color-custom];
  }
}
